<template>
    <v-container
        fluid
        grid-list-lg
    >
        <v-layout
            row
            wrap
        >
            <v-flex
                xs12
                sm6
                offset-sm3
            >
                <v-alert
                    :value="true"
                    v-if="error != null"
                    type="error"
                >{{
                    error.message
                    }}</v-alert>

                <v-layout
                    justify-center
                    column
                >
                    <v-form
                        ref="form"
                        v-model="valid"
                        @submit="signUp"
                    >
                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="firstName"
                                    :rules="firstNameRules"
                                    label="First Name *"
                                    required
                                ></v-text-field>
                            </v-flex>

                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="lastName"
                                    :rules="lastNameRules"
                                    label="Last Name *"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="username"
                                    :rules="usernameRules"
                                    type="email"
                                    label="Email Address *"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                sm2
                            >Date of Birth</v-flex>
                            <v-flex
                                xs12
                                sm3
                            >
                                <v-select
                                    :items="days"
                                    label="DD"
                                    v-model="dobDay"
                                    :rules="dobRules"
                                    required
                                    outline
                                ></v-select>
                            </v-flex>
                            <v-flex
                                xs12
                                sm3
                            >
                                <v-select
                                    :items="months"
                                    label="MM"
                                    v-model="dobMonth"
                                    :rules="dobRules"
                                    outline
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex
                                xs12
                                sm4
                            >
                                <v-select
                                    :items="years"
                                    label="YYYY"
                                    v-model="dobYear"
                                    :rules="dobRules"
                                    outline
                                    required
                                ></v-select>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                sm2
                            >Set Password</v-flex>
                            <v-flex
                                xs12
                                sm5
                            >
                                <v-text-field
                                    outline
                                    ref="pass"
                                    v-model="pass"
                                    :rules="passRules"
                                    label="Password *"
                                    type="password"
                                    required
                                ></v-text-field>
                            </v-flex>

                            <v-flex
                                xs12
                                sm5
                            >
                                <v-text-field
                                    outline
                                    ref="passConfirm"
                                    v-model="passConfirm"
                                    :rules="passConfirmRules"
                                    label="Confirm Password *"
                                    type="password"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <p class="password-notice">
                                    A valid password must contain one upper case letter, one lower
                                    case letter, a number and a special character (e.g. ^ $ * . !
                                    @ # % &amp;) and also must be at least 8 characters in length.
                                </p>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="address1"
                                    :rules="addressRules"
                                    label="Address line 1*"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="address2"
                                    label="Address line 2"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="address3"
                                    label="Address line 3"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="locality"
                                    label="City / Town"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="region"
                                    label="County / Region"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-text-field
                                    outline
                                    v-model="postal_code"
                                    :rules="addressRules"
                                    label="Postal Code*"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-select
                                    outline
                                    :items="countries"
                                    v-model="country"
                                    item-text="name"
                                    label="Country*"
                                ></v-select>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                pb-0
                            >
                                <v-switch
                                    :label="`I want to receive email communications from {{configStrings.clubName}}  `"
                                    v-model="clubEmail"
                                    color="#660033"
                                ></v-switch>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                py-0
                            >
                                <v-switch
                                    :label="`I want to receive emails from Official Club Partners (occasional offers and promotions)`"
                                    v-model="partnerEmail"
                                    color="#660033"
                                ></v-switch>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <p class="notice">
                                    You can access our preference centre at any time to opt-out of
                                    communications and control how we use your data.
                                </p>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                pt-0
                                pb-1
                            >
                                <v-switch
                                    id="termsSwitch"
                                    :label="`I have read and understood the Club's privacy policy`"
                                    v-model="termsAgree"
                                    :rules="termsAgreeRules"
                                    color="#660033"
                                ></v-switch>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex
                                xs12
                                pt-0
                                pb-3
                            >
                                <p>
                                    <a
                                        class="privacy-policy text-button"
                                        href="https://www.avfc.co.uk/club/legal/privacy-policy"
                                        target="_blank"
                                    >https://www.avfc.co.uk/club/legal/privacy-policy</a>
                                </p>
                            </v-flex>
                        </v-layout>

                        <v-layout
                            row
                            align-center
                            mx-1
                            py-0
                        >
                            <router-link
                                to="/"
                                class="text-button"
                            >Already registered?</router-link>
                            <v-spacer />
                            <button
                                type="submit"
                                class="button"
                                :disabled="!valid"
                            >
                                Register
                            </button>
                        </v-layout>
                    </v-form>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: "Registration",
    data() {
        return {
            valid: true,
            firstNameRules: [(v) => !!v || "First name is required"],
            lastNameRules: [(v) => !!v || "Last name is required"],
            dobRules: [
                (v) => !!v || "Date of Birth is required",
                (v) =>
                    (
                        this.dobYear +
                        "-" +
                        ("0" + this.dobMonth).slice(-2) +
                        "-" +
                        ("0" + this.dobYear).slice(-2)
                    ).toString() < new Date().toISOString().split("T")[0] ||
                    "Date can't be in the future",
            ],
            countryRules: [(v) => !!v || "Country is required"],
            passRules: [
                (v) => !!v || "Password is required",
                (v) => (v && v.length >= 8) || "Password must be at least 8 characters",
                (v) =>
                    /.*[a-z].*/.test(v) ||
                    "Password must contain at least one lower case letter",
                (v) =>
                    /.*[A-Z].*/.test(v) ||
                    "Password must contain at least one upper case letter",
                (v) => /\d/.test(v) || "Password must contain at least one number",
                (v) =>
                    /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) ||
                    "Password must contain at least one special character (e.g. ^ $ * . ! @ # % &)",
                (v) =>
                    (this.passConfirm.length >= 8 && v == this.passConfirm) ||
                    "Password confirmation must match password",
            ],
            passConfirmRules: [
                (v) => v == this.pass || "Password confirmation must match password",
            ],
            usernameRules: [
                (v) => !!v || "Email address is required",
                (v) => /.+@.+/.test(v) || "Email must be valid",
                (v) =>
                    !v.includes(" ") || "An email address can not contain any spaces",
            ],
            termsAgreeRules: [(v) => !!v || "You must agree to continue"],
            addressRules: [(v) => !!v || "You must fill in this address field"],
            firstName: "",
            lastName: "",
            username: "",
            pass: "",
            dobDay: null,
            dobMonth: null,
            dobYear: null,
            address1: "",
            address2: "",
            address3: "",
            locality: "",
            region: "",
            postal_code: "",
            country: "",
            countries: [],
            clubEmail: false,
            partnerEmail: false,
            termsAgree: false,
            passConfirm: "",
            error: null,
            loading: false,
            days: [],
            months: [],
            years: [],
        };
    },
    created() {
        fetch("/countries.json")
            .then((r) => r.json())
            .then(
                (json) => {
                    this.countries = json.countries;
                },
                (response) => { }
            );
        this.populateDates();
    },
    watch: {
        pass: function (val, oldVal) {
            this.$refs.form.validate();
        },
        passConfirm: function (val, oldVal) {
            this.$refs.form.validate();
        },
        dobDay: function (val, oldVal) {
            this.$refs.form.validate();
        },
        dobMonth: function (val, oldVal) {
            this.$refs.form.validate();
        },
        dobYear: function (val, oldVal) {
            this.$refs.form.validate();
        },
    },
    methods: {
        pad(num, size) {
            var s = num + "";
            while (s.length < size) s = "0" + s;
            return s;
        },
        populateDates() {
            for (var d = 1; d < 32; d++) {
                this.days.push(d);
            }
            for (var m = 1; m < 13; m++) {
                this.months.push(m);
            }
            var thisYear = new Date().getFullYear();
            for (var y = thisYear + 1; y > 1900; y--) {
                this.years.push(y);
            }
        },
        signUp(e) {
            e.preventDefault();
            this.loading = true;
            var email = this.username;
            var password = this.pass;
            var firstName = this.firstName;
            var lastName = this.lastName;
            var clubEmail = this.clubEmail.toString();
            var partnerEmail = this.partnerEmail.toString();
            var termsAgree = this.termsAgree.toString();

            var attributesList = {
                given_name: firstName,
                family_name: lastName,
                "custom:club_email": clubEmail,
                "custom:partner_email": partnerEmail,
                "custom:privacy_accepted": termsAgree,
            };

            var street_address =
                this.address1 + "\n" + this.address2 + "\n" + this.address3;

            var address = {
                street_address: street_address,
                locality: this.locality,
                region: this.region,
                postal_code: this.postal_code,
                country: this.country,
            };
            attributesList["address"] = JSON.stringify(address);

            if (this.dobDay && this.dobMonth && this.dobYear) {
                attributesList["birthdate"] =
                    this.dobYear +
                    "-" +
                    this.pad(this.dobMonth, 2) +
                    "-" +
                    this.pad(this.dobDay, 2);
            }

            this.$signUp(email, password, attributesList).subscribe(
                (data) => {
                    this.$router.push("/confirm");
                },
                (err) => {
                    //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito

                    if (
                        err.message === "An account with the given email already exists."
                    ) {
                        err.message =
                            "This is an existing Villa " +
                            this.configStrings.AltProductName +
                            " - Please click here to reset your password to create your new " +
                            this.configStrings.AltProductName +
                            "";
                    }
                    this.error = err;
                }
            );
        },
    },
};
</script>

<style>
.password-notice {
    margin: 0 0 20px;
    padding: 0 0 40px;
    color: #878787;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid #eee;
}

.v-input--switch__track.theme--light.error--text {
    color: rgba(0, 0, 0, 0.38) !important;
}

.v-input--selection-controls__ripple.error--text {
    color: #fff !important;
}

.v-input--switch__thumb.theme--light.error--text {
    color: #fafafa !important;
}
</style>
